export default [
  {
    path: '/',
    name: 'PcHome',
    component: () => import('@/views/pc/home/Index.vue'),
  },
  {
    path: '/home',
    name: 'PcHome',
    component: () => import('@/views/pc/home/Index.vue'),
  },
  {
    path: '/list',
    name: 'PcList',
    component: () => import('@/views/pc/list/Index.vue'),
  },
  {
    path: '/news',
    name: 'PcNews',
    component: () => import('@/views/pc/news/Index.vue'),
  },
  {
    path: '/404',
    name: 'Pc404',
    component: () => import('@/views/pc/404.vue'),
  },
]